/**
 * "Rechercher un dossier" (mahhp 22861) — config of the claim search modal
 * (`ClaimSearchModal`) and its header trigger (`ClaimFlowHeader`).
 *
 * Every user-facing text of the feature lives here under a stable key — never
 * inline in JSX. The modal and its trigger are module chrome: like
 * `ClaimFlowHeader`, they are deliberately not registered as configurable
 * components.
 */

const MIN_QUERY_LENGTH = 2;

export const CLAIM_SEARCH_CONFIG = {
  /** Typeahead debounce, in ms. */
  debounceMs: 300,
  /** Below this many (trimmed) characters no search is sent. */
  minQueryLength: MIN_QUERY_LENGTH,
  text: {
    /** Header trigger: tooltip + accessible name. */
    trigger: 'Rechercher un dossier',
    title: 'Rechercher un dossier',
    /** Accessible name of the search input. */
    inputLabel: 'Rechercher un dossier',
    placeholder: 'N° de dossier, référence ou client…',
    hint: `Saisissez au moins ${String(MIN_QUERY_LENGTH)} caractères pour lancer la recherche.`,
    empty: 'Aucun dossier',
    error: 'La recherche a échoué. Veuillez réessayer.',
    /** Tooltip of a result VEOS returned without `ID_SIN` (cannot be opened). */
    missingIdSin: 'Identifiant du dossier indisponible',
    /** Between `NCBT_SIN` and `NCIE_SIN` on a result's first line. */
    referenceSeparator: ' · ',
  },
} as const;

/**
 * URL of the claim screen for a search result — the task-less route
 * (`/task?id_sin=…`). Absolute (built on `origin`) because it is opened in a
 * NEW tab, which has no router state: the session id must ride in the URL.
 */
export function buildClaimSearchResultUrl(args: {
  origin: string;
  tenantSlug: string;
  idSin: number;
  ses: string | null;
}): string {
  const params = new URLSearchParams({ id_sin: String(args.idSin) });
  if (args.ses) params.set('ses', args.ses);
  return `${args.origin}/claimflow/${encodeURIComponent(args.tenantSlug)}/task?${params.toString()}`;
}
